import React from 'react';
import {
  FDBox, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  EstatePlanningC2BWrapper,
} from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/components/EstatePlanningC2BWrapper';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dispatchWizardFinishedRefresh } from 'Hooks/useRefreshEvent';

const EstatePlanningBuyLearnMoreStepLayout = () => {
  const {
    saving,
    resource,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  return (
    <EstatePlanningC2BWrapper>
      <MetaControlField
        attr={'subtitle'}
        hideEmptyFields
      />
      <FDBox paddingY={2}>
        <FDStack direction={'row'} alignItems={'flex-start'} spacing={2}>
          <FDPrimaryActionButton
            onClick={() => {
              clearModalCollection();
              dispatchWizardFinishedRefresh();
            }}
            label={resource.attr('primaryActionLabel') || 'Finish'}
            loading={saving}
          />
        </FDStack>
      </FDBox>
    </EstatePlanningC2BWrapper>
  );
};

EstatePlanningBuyLearnMoreStepLayout.defaultProps = {
};

EstatePlanningBuyLearnMoreStepLayout.propTypes = {
};

export { EstatePlanningBuyLearnMoreStepLayout };
